const hostName = window.location.hostname === "localhost" ? "http://localhost:8000" : "https://backend.bitbots.io"

export default hostName